import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 text-gray-400 py-6 px-4 border-t border-gray-800 text-center" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <p className="font-bold text-white mb-2" data-id="element-63">
          🧠 KIT COMPLETO PSICOLOGÍA LISTA
        </p>
        <p className="mb-3" data-id="element-64">© 2026 Kit Completo Psicología Lista™</p>
        <div className="flex justify-center gap-6 text-sm" data-id="element-65">
          <span className="cursor-pointer hover:text-white" data-id="element-66">Términos</span>
          <span className="cursor-pointer hover:text-white" data-id="element-67">Privacidad</span>
          <span className="cursor-pointer hover:text-white" data-id="element-68">Soporte</span>
        </div>
      </div>
    </footer>;
}